<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link class="btn btn-primary btn-round" :to="{name:'Users'}">back</b-link>
      </template>
    </navbar>
    <!--navbar-->


    <b-card title="information">
      <b-form-group
          class="required"
          label="username"
          :state="!validation.hasError('name')"
          :invalid-feedback="validation.errorTitle('name')"
      >
        <b-input
            v-model="form.name"></b-input>
      </b-form-group>
      <b-form-group
          class="required"
          label="email"
          :state="!validation.hasError('email')"
          :invalid-feedback="validation.errorTitle('email')"
      >
        <b-input
            type="email"
            v-model="form.email"></b-input>
      </b-form-group>
      <b-form-group
          class="required"
          label="password"
          :state="!validation.hasError('password')"
          :invalid-feedback="validation.errorTitle('password')"
      >
        <b-input
            type="password"
            v-model="form.password"></b-input>

        <p>{{ form.password }}</p>
      </b-form-group>
      <b-form-group
          class="required"
          label="role"
      >
        <b-form-select
            v-model="form.role"
            :options="roles"
        >

        </b-form-select>
      </b-form-group>

      <b-form-group>
        <b-button variant="success" @click="storeUser">Save</b-button>
      </b-form-group>
    </b-card>
  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import Validation from '../../Services/Validation/Validation'

export default {
  name: "AddUser",
  components: {Navbar},
  data() {
    return {
      validation: new Validation(),
      roles: [
        {
          text: 'user',
          value: 'user'
        },
        {
          text: 'admin',
          value: 'admin'
        },
        {
          text: 'seo manager',
          value: 'seo_manager'
        },
        {
          text: 'Angestellter',
          value: 'order_manager'
        },
        {
          text: 'Manager',
          value: 'manager'
        },

      ],
      form: {
        name: null,
        email: null,
        password: null,
        role: 'user',
      }
    }
  },
  methods: {
    storeUser() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'user/store', this.form)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              Notification.success(response.data.message);
              this.$router.push({name: 'Users'});
            } else {
              Notification.error(response.data.message);

              this.validation.store(response.data.data);
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    }
  }
}
</script>

<style scoped>

</style>